<input matInput
  #typeaheadInput
  #autocompleteTrigger="matAutocompleteTrigger"
  autocomplete="new-password"
  name="trial_responsible-{{id}}"
  class="typeahead-input"
  [matAutocomplete]="ftmsAutocomplete"
  [formControl]="inputControl"
  [(ngModel)]="textValue"
  type="text"
  (blur)="onTouchedFn()" />

@if (value) {
  <mat-icon class="clear-input-icon" (click)="clearTypeahead()">close</mat-icon>
}

<mat-autocomplete #ftmsAutocomplete="matAutocomplete" panelClass="standard-modal-panel"
  [displayWith]="DisplayItem">

  @if (value !== undefined) {
    @for (item of getFullList(); track item) {
      <mat-option [value]="item">
        {{item.DisplayText}}
      </mat-option>
    }
  }

  @if (value === undefined) {
    @for (item of FilteredList | async; track item) {
      <mat-option [value]="item">
        {{item.DisplayText}}
      </mat-option>
    }
  }
</mat-autocomplete>
